<template>
  <h1 hidden></h1>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import lottie from "vue-lottie";
import axios from "axios";

export default {
  name: "logout-process",
  components: { "m-anim": lottie },
  computed: {
    ...mapGetters(["getScreen", "getAuth"]),
  },
  created() {
    this.fetch(this.getAuth.id_user);
  },
  data() {
    return {
      previewVisible: false,
    };
  },
  methods: {
    fetch(idValue) {
      localStorage.removeItem("key_sim_infog");
      window.location = this.$urlPandapaKita;
    },
  },
};
</script>

